import axios from "axios";
import { ONBOARDING_API_ENDPOINT } from "../config/url.config";
import { getDocumentListForMember } from "../services/ondemandApi";
import { navigateToSessionExpired } from "../utils/sessionExpired";
import { checkDocumentIsUpdatedByUser, documentsWasUpdatedByUser } from "../utils/updatedByUser";
import { getAuthHeader } from "../utils/superFetch";

export const handleDriverProfileSubmit = async (memberRequirement, setValidation, setErrorMessage, navigate, selectedProfileType, showSaveButton ) => {
    try {
      if(!showSaveButton) {
        for (let doc of memberRequirement.requiredDocuments) {
          for (let item of doc.requiredItems) {
              if(item.value === '') {
                setValidation(true)
                setErrorMessage(`Update the following documents before submitting : ${doc.displayName}`)
              }
          }
        }
      }
      

      const config = {
        headers: { "content-type": "application/json", ...getAuthHeader() },
      };

      const res = await axios.post(
        `${ONBOARDING_API_ENDPOINT}/api/onboarding/saveDocument?profileType=${selectedProfileType.profileId}`,
        {},
        config
      );

      if (res.status) {
        navigate('/completed')
      }

    } catch (err) {
      console.log("error", err.message)
    }
}
export const handleGetRequirementForMember = async (setMemberRequirement, setDocumentStatus,setPageLoading,setShowSaveButton, navigate, profileId, 
  redirectToDocument, setSelectedItemIndex, setOpenUploadDocument) => {
    try {
      let response = await getDocumentListForMember(profileId);
      
      if (!response.status) {
        
        navigateToSessionExpired(navigate, {
          reason: "member_requirements_invalid_response",
          source: "handleGetRequirementForMember",
          component: "RequirementListForMember",
        })
        
        return;
      }
      setMemberRequirement(response.result.documents);
      setDocumentStatus(response.result.status)
      setPageLoading(false)

      if(redirectToDocument === "updateVehicleDocuments") {
        
        for(let i = 0 ; i < response.result.documents.requiredDocuments.length ; i++) {
          if(response.result.documents.requiredDocuments[i].item === "vehicleDetails") {

            setSelectedItemIndex(i);
    
            setOpenUploadDocument({
              openDocument: true,
              documentType:
              response.result.documents.requiredDocuments[i].item,
            });
            sessionStorage.removeItem('redirectToDocument')

            return 
          }
        }


      } 

      for(let doc of response.result.documents.requiredDocuments) {
        for (let item of doc.requiredItems) { //
          if (item.value === '' && doc.item !== "emergencyContact" && !["letterOfEmployment", "issueDate", "expiryDate"].includes(item.itemName) ) {
            setShowSaveButton(false)
            return
          } else if (item.status === 2 && !checkDocumentIsUpdatedByUser(doc.item)) {
            setShowSaveButton(false)
            return
          } else {
            continue
          }
        }
      }
      setShowSaveButton(true)
      
      return

    } catch (err) {
      console.log("Err", err.message);
    }
};

export const checkRequiredItemsStatus = (requiredDocumentItem, memberStatus) => {
    
  let itemStatusCategory = {
      userUploadedDocuments : 'userUploadedDocuments' , 
      emptyDocuments : 'emptyDocuments' , 
      rejectedDocuments : 'rejectedDocuments' , 
      updatedRejectedDocuments : 'updatedRejectedDocuments' ,
      pendingDocumentApproval : 'pendingDocumentApproval'
    } 

    let documentStatus = '' 
    
    for (let item of requiredDocumentItem.requiredItems) {
      if(item.status === 0 && memberStatus === 4){
        documentStatus = itemStatusCategory.pendingDocumentApproval
        break
      } else if ((!item.status || item.status === 0 || item.status === 1 ) && item.value !== '' ) {
        documentStatus = itemStatusCategory.userUploadedDocuments
        if (checkDocumentIsUpdatedByUser(requiredDocumentItem.item)){
          documentStatus = itemStatusCategory.updatedRejectedDocuments
        }
      }else if (item.status && item.status === 2 && item.value !== '' ) {
        documentStatus = itemStatusCategory.rejectedDocuments
        if (checkDocumentIsUpdatedByUser(requiredDocumentItem.item)){
          documentStatus = itemStatusCategory.updatedRejectedDocuments
        }
        break
      } else if (checkDocumentIsUpdatedByUser(requiredDocumentItem.item)) {
        documentStatus = itemStatusCategory.updatedRejectedDocuments
        break
      } else {
        documentStatus = itemStatusCategory.emptyDocuments
        break
      }
     }

     return documentStatus
}

export const updateMemberRequirement = (memberRequirement,setMemberRequirement, itemIndex, itemName, updatedValue, updatedUrl) => {
    let tmpData = {...memberRequirement}
    for (let i = 0 ; i< tmpData.requiredDocuments[itemIndex].requiredItems.length ;i++) {
      if (
        itemName === tmpData.requiredDocuments[itemIndex].requiredItems[i].itemName
      ) {
        if(tmpData.requiredDocuments[itemIndex].requiredItems[i].status === 2 || 
          tmpData.requiredDocuments[itemIndex].requiredItems[i].value !== '') {
          documentsWasUpdatedByUser(`${tmpData.requiredDocuments[itemIndex].item}`)
        }
        tmpData.requiredDocuments[itemIndex].requiredItems[i].value = updatedValue
        tmpData.requiredDocuments[itemIndex].requiredItems[i].url = updatedUrl
        break
      }
    }
    setMemberRequirement(tmpData)
    return
}

export const handleImageUpload = async (file, itemName, item, 
    setImageUrlInState, setValidation, setUpdatedByUser,
     setSubmitButton, memberRequirement,setMemberRequirement, itemIndex, navigate, profileid) => {

    const formData = new FormData();
    formData.append("file", file);
    formData.append("inputType", "image");
    formData.append("itemName", itemName);
    formData.append("item", item);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
        "upload-document": true,
        ...getAuthHeader(),
      },
    };
    try {
      const endpoint = `${ONBOARDING_API_ENDPOINT}/api/onboarding/updateConfiguration?profileType=${profileid}`;
      const res = await axios.post(endpoint, formData, config);

      setImageUrlInState(URL.createObjectURL(file))
      setValidation(() => { return { show: false, message: "", class: "" }})
      setUpdatedByUser(true)
      if ( setSubmitButton !== {} ) setSubmitButton('Replace');
      updateMemberRequirement(memberRequirement,setMemberRequirement, itemIndex, itemName, res.data.result.itemValue, res.data.result.url)
      
      
    } catch (err) {
      navigateToSessionExpired(navigate, {
        reason: "document_upload_failed",
        source: "handleImageUpload",
        component: item,
        status: err?.response?.status,
        message: err?.message,
        item,
        itemName,
      });
    }

}